import { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  activityAnalysisListName,
  approversCardDocumentListName,
  copiesCardDocumentListName,
  documentByCardFilesLibName,
  emailsSender,
  equipmentsByDocumentListName,
  favoriteDocumentsListName,
  historyByDocumentListName,
  historyChangeFieldsDocumentListName,
  myDocumentsListName,
  preprod,
  settingsListName,
  siteUrl,
  versionsByDocumentListName,
} from "src/api/config";
import { strapiCheckUrl } from "../users/constants";
import { useAppDispatch } from "src/hooks/redux";
import { getItems } from "src/modules/spItems/actions";
import { getCurrentUserRequest } from "../users/api";
import { AuthContext } from "src/contexts/AuthContext";
import { authService } from "../authMobile/authService";
import { addItemRequest, deleteItemRequest, getItemsRequest, updateItemRequest } from "../spItems/api";
import moment from "moment";
import { notificationsCardListName, notificationsListName } from "src/api/config/notifications.config";
import { docStatuses, notificationStatuses } from "src/api/config/systemSwitch";
import { myTasksAuditListName } from "src/api/config/myTasksAudit.config";
import { myTasks5WayListName, myTasksSDCA5WayListName } from "src/api/config/myTasks5Way.config";
import { emailQueueListName } from "src/api/config/email.config";
import { emailAPI } from "src/utils/api.utils";
import { myTaskActionsListName } from "src/api/config/myTasksActions.config";

const delay = (ms: number) => new Promise(res => setTimeout(res, ms));
const STORAGE_KEY = 'script_nextPage';
const { sendEmail } = emailAPI();

const HeadInfo = () => {
  const location = useLocation();
  const [favicon, setFavicon] = useState(
    `${siteUrl}/favicon.ico?v=${new Date().getTime()}`
  );
  const [title, setTitle] = useState("Supply Portal");
  const dispatch = useAppDispatch();
  const [auth, setAuth] = useState(false);
  const navigate = useNavigate();

  const { isAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    const faviconElem: any = document.querySelector("link[rel='icon']");
    if (faviconElem) {
      faviconElem.href = favicon;
    }
  }, [favicon]);

  useEffect(() => {
    const titleElem: any = document.querySelector("title");
    if (titleElem) {
      titleElem.innerText = title;
    }
  }, [title]);

  useEffect(() => {
    if (isAuthenticated) {
      console.log("window.strapiUser: ", window.strapiUser);
      getItemsRequest({
        listName: equipmentsByDocumentListName,
        filters: { Line: null, Equipment: null },
      }).then((results) => {
        const equipmentsIds = results.items.map((item) => {
          return { ID: item.ID };
        });
        deleteItemRequest({
          listName: equipmentsByDocumentListName,
          ID: 0,
          Ids: equipmentsIds,
        }).then((results) => {
          if (!results?.items) return;
          const equipmentsIds = results.items.map((item) => {
            return { ID: item.ID };
          });
          deleteItemRequest({
            listName: equipmentsByDocumentListName,
            ID: 0,
            Ids: equipmentsIds,
          }).then((results) => {
            console.log('Удалили пустые карточки оборудования')
            getItemsRequest({
              listName: myTasksSDCA5WayListName,
              filters: { _x0035_Way: null },
            }).then((results) => {
              const sdcaIds = results.items.map((item) => {
                return { ID: item.ID };
              });
              deleteItemRequest({
                listName: myTasksSDCA5WayListName,
                ID: 0,
                Ids: sdcaIds,
              }).then(() => {
                console.log('Удалили пустые инструменты');
                // Cкрипт для обновления дейсвий у карточек 5П
                // const PAGE_SIZE = 15;
                // const UPDATE_CHUNK = 10;

                // const sleep = (ms: number) =>
                //   new Promise(resolve => setTimeout(resolve, ms));

                // const updateFiveWayActions = async (
                //   fiveWay: any,
                //   attempt: number = 1
                // ): Promise<void> => {
                //   const maxAttempts = 3;

                //   try {
                //     console.log(
                //       `[${attempt}/${maxAttempts}] Обрабатываем карточку ${fiveWay.ID}`
                //     );

                //     //
                //     // 1. Действия самой карточки
                //     //
                //     const cardActions = await getItemsRequest({
                //       listName: myTaskActionsListName,
                //       filters: {
                //         ImportantHashTag: `#5Почему_${fiveWay.ID}A*`,
                //       },
                //     });

                //     if (cardActions.items.length) {
                //       console.log(
                //         `Найдено действий карточки: ${cardActions.items.length}`
                //       );

                //       for (let i = 0; i < cardActions.items.length; i += UPDATE_CHUNK) {
                //         const chunk = cardActions.items.slice(i, i + UPDATE_CHUNK);

                //         await Promise.all(
                //           chunk.map(action =>
                //             updateItemRequest({
                //               listName: myTaskActionsListName,
                //               body: {
                //                 ID: action.ID,
                //                 ImportantHashTag: `#5Почему_${fiveWay.ID}`,
                //               },
                //             })
                //           )
                //         );
                //       }
                //     }

                //     //
                //     // 2. Получаем инструменты
                //     //
                //     const tools = await getItemsRequest({
                //       listName: myTasksSDCA5WayListName,
                //       filters: {
                //         _x0035_Way: fiveWay.ID,
                //       },
                //     });

                //     console.log(
                //       `Найдено инструментов: ${tools.items.length}`
                //     );

                //     //
                //     // 3. Для каждого инструмента
                //     //
                //     for (const tool of tools.items) {
                //       const toolActions = await getItemsRequest({
                //         listName: myTaskActionsListName,
                //         filters: {
                //           ImportantHashTag: `#5Почему_${tool.ID}`,
                //         },
                //       });

                //       if (!toolActions.items.length) {
                //         continue;
                //       }

                //       console.log(
                //         `Инструмент ${tool.ID}: ${toolActions.items.length} действий`
                //       );

                //       for (
                //         let i = 0;
                //         i < toolActions.items.length;
                //         i += UPDATE_CHUNK
                //       ) {
                //         const chunk = toolActions.items.slice(
                //           i,
                //           i + UPDATE_CHUNK
                //         );

                //         await Promise.all(
                //           chunk.map(action =>
                //             updateItemRequest({
                //               listName: myTaskActionsListName,
                //               body: {
                //                 ID: action.ID,
                //                 ImportantHashTag: `#5Почему_${fiveWay.ID}`,
                //                 SDCA: tool.SDCA.get_lookupId(),
                //               },
                //             })
                //           )
                //         );
                //       }
                //     }

                //     console.log(
                //       `✅ Карточка ${fiveWay.ID} успешно обработана`
                //     );
                //   } catch (error) {
                //     console.error(
                //       `❌ Ошибка карточки ${fiveWay.ID}`,
                //       error
                //     );

                //     if (attempt < maxAttempts) {
                //       console.log(`Повтор через 2 секунды...`);
                //       await sleep(2000);
                //       return updateFiveWayActions(fiveWay, attempt + 1);
                //     }

                //     console.error(
                //       `❌ Карточка ${fiveWay.ID} пропущена`
                //     );
                //   }
                // };

                // const processAllFiveWays = async () => {
                //   console.log("🚀 Начинаем миграцию действий 5Почему");

                //   let page = 835;
                //   let processed = 0;

                //   while (true) {
                //     const fiveWays = await getItemsRequest({
                //       listName: myTasks5WayListName,
                //       filters: {
                //         Type5Way: "FiveWay",
                //       },
                //       rowLimit: PAGE_SIZE,
                //       nextPage: page,
                //       sortOrder: { name: "ID", desc: true }
                //     });

                //     if (!fiveWays.items.length) {
                //       break;
                //     }

                //     console.log(
                //       `Получено ${fiveWays.items.length} карточек`
                //     );

                //     for (const card of fiveWays.items) {
                //       await updateFiveWayActions(card);

                //       processed++;

                //       console.log(
                //         `Обработано карточек: ${processed}`
                //       );

                //       await sleep(500);
                //     }
                //     console.log(`Обработана страница ${page}`);
                //     page++;
                //   }

                //   console.log(
                //     `🏁 Миграция завершена. Всего карточек: ${processed}`
                //   );
                // };

                // processAllFiveWays().then(() => {
                //   console.log("Готово");
                //   setAuth(true);
                // });
                setAuth(true);
              })
            });
            //Скрипт для отправки битых доков на доработку, в массив добавить id доков
            // const documents = [];
            // const deleteDocumentAndRelatedData = async (documentId: number, attempt: number = 1): Promise<void> => {
            //   const maxAttempts = 3;

            //   try {
            //     console.log(`[${attempt}/${maxAttempts}] Начинаем обработку документа ${documentId}`);

            //     const [mainDoc] = (await getItemsRequest({
            //       listName: myDocumentsListName,
            //       filters: { ID: documentId },
            //     })).items;

            //     if (!mainDoc) {
            //       console.warn(`Документ ${documentId} не найден`);
            //       return;
            //     }

            //     const cardId = mainDoc.ID;

            //     // 1. Собираем запросы на связанные данные
            //     const requests = {
            //       activity: getItemsRequest({ listName: activityAnalysisListName, filters: { Document: cardId } }),
            //       favorites: getItemsRequest({ listName: favoriteDocumentsListName, filters: { Document: cardId } }),
            //       documents: getItemsRequest({ listName: documentByCardFilesLibName, filters: { CardID: cardId, VersionDocument: false } }),
            //       approvers: getItemsRequest({ listName: approversCardDocumentListName, filters: { Document: cardId, VersionDocument: false } }),
            //       equipments: getItemsRequest({ listName: equipmentsByDocumentListName, filters: { Document: cardId, VersionDocument: false } }),
            //       history: getItemsRequest({ listName: historyByDocumentListName, filters: { DocumentID: cardId, VersionDocument: false } }),
            //       historyFields: getItemsRequest({ listName: historyChangeFieldsDocumentListName, filters: { DocumentID: cardId, VersionDocument: false } }),
            //       notifications: getItemsRequest({ listName: notificationsListName, filters: { Document: cardId } }),
            //       copies: getItemsRequest({ listName: copiesCardDocumentListName, filters: { DocumentID: cardId } }),
            //       listsApprovers: getItemsRequest({ listName: listsApproversListName, filters: { DocumentID: cardId } }),
            //       emailQueue: getItemsRequest({ listName: emailQueueListName, filters: { CheckDoc: String(cardId) } }),
            //     };

            //     const results = await Promise.all(Object.values(requests));

            //     const deletePromises: Promise<any>[] = [];

            //     const addDeletes = (items: any[], listName: string, fileField?: string) => {
            //       items.forEach(item => {
            //         deletePromises.push(
            //           deleteItemRequest({
            //             listName,
            //             ID: item.ID,
            //             ...(fileField && { fileField }),
            //           })
            //         );
            //       });
            //     };

            //     // Основные данные
            //     addDeletes(results[0]?.items || [], activityAnalysisListName);
            //     addDeletes(results[1]?.items || [], favoriteDocumentsListName);
            //     addDeletes(results[2]?.items || [], documentByCardFilesLibName, "File");
            //     addDeletes(results[3]?.items || [], approversCardDocumentListName);
            //     addDeletes(results[4]?.items || [], equipmentsByDocumentListName);
            //     addDeletes(results[5]?.items || [], historyByDocumentListName);
            //     addDeletes(results[6]?.items || [], historyChangeFieldsDocumentListName);
            //     addDeletes(results[7]?.items || [], notificationsListName);
            //     addDeletes(results[8]?.items || [], copiesCardDocumentListName);
            //     addDeletes(results[9]?.items || [], listsApproversListName);
            //     addDeletes(results[10]?.items || [], emailQueueListName);

            //     // Обработка версий
            //     const versionsResult = await getItemsRequest({
            //       listName: versionsByDocumentListName,
            //       filters: { MainDocument: cardId },
            //     });

            //     const versions = versionsResult.items || [];

            //     for (const version of versions) {
            //       const versionId = version.ID;

            //       deletePromises.push(deleteItemRequest({ listName: versionsByDocumentListName, ID: versionId }));

            //       const versionRequests = await Promise.all([
            //         getItemsRequest({ listName: documentByCardFilesLibName, filters: { CardID: versionId, VersionDocument: true } }),
            //         getItemsRequest({ listName: approversCardDocumentListName, filters: { Document: versionId, VersionDocument: true } }),
            //         getItemsRequest({ listName: equipmentsByDocumentListName, filters: { Document: versionId, VersionDocument: true } }),
            //         getItemsRequest({ listName: historyByDocumentListName, filters: { DocumentID: versionId, VersionDocument: true } }),
            //         getItemsRequest({ listName: historyChangeFieldsDocumentListName, filters: { DocumentID: versionId, VersionDocument: true } }),
            //       ]);

            //       addDeletes(versionRequests[0]?.items || [], documentByCardFilesLibName, "File");
            //       addDeletes(versionRequests[1]?.items || [], approversCardDocumentListName);
            //       addDeletes(versionRequests[2]?.items || [], equipmentsByDocumentListName);
            //       addDeletes(versionRequests[3]?.items || [], historyByDocumentListName);
            //       addDeletes(versionRequests[4]?.items || [], historyChangeFieldsDocumentListName);
            //     }

            //     // Выполняем все удаления
            //     if (deletePromises.length > 0) {
            //       await Promise.all(deletePromises);
            //     }

            //     console.log(`✅ Документ ${documentId} успешно очищен от связанных данных`);

            //     // === Добавление новой информации после очистки ===
            //     const dataHistoryCard = {
            //       Title: `History card # ${documentId}`,
            //       Comment: 'Отправлено на доработку в связи с обновлениями системы. Пожалуйста, проверьте и отправьте документ на согласование повторно. Обновите дату пересмотра и загрузите актуальный файл',
            //       Approvers: ['supply.portal@abinbevefes.com'],
            //       DocumentID: documentId,
            //       ApprovalGroup: 12,
            //       Statuses: [docStatuses.sendRevision],
            //     };

            //     const historyFields = {
            //       Title: `History fields card # ${documentId}`,
            //       DocumentID: documentId,
            //       Statuses: [docStatuses.sendRevision],
            //       Comment: 'Отправлено на доработку в связи с обновлениями системы. Пожалуйста, проверьте и отправьте документ на согласование повторно. Обновите дату пересмотра и загрузите актуальный файл',
            //     };

            //     const approversData = {
            //       Denied: 'supply.portal@abinbevefes.com',
            //       Queue: false,
            //       Statuses: [docStatuses.revision],
            //       VersionDocument: false,
            //       Title: `Approver card # ${documentId}`,
            //       Approvers: [mainDoc.AuthorEmail.toLowerCase()],
            //       Group: 6,
            //       Document: documentId
            //     };

            //     await addItemRequest({ listName: historyByDocumentListName, body: dataHistoryCard });
            //     const idHisroryCard = await addItemRequest({ listName: historyChangeFieldsDocumentListName, body: historyFields });

            //     await updateItemRequest({ listName: historyChangeFieldsDocumentListName, body: { ID: idHisroryCard, Author: 'supply.portal@abinbevefes.com' } });
            //     await updateItemRequest({ listName: myDocumentsListName, body: { ID: documentId, Status: docStatuses.revision } });

            //     const idApproversCard = await addItemRequest({ listName: approversCardDocumentListName, body: approversData });
            //     await updateItemRequest({ listName: approversCardDocumentListName, body: { ID: idApproversCard, Author: mainDoc.AuthorEmail.toLowerCase() } });

            //     if (emailsSender) {
            //       const emailBody = {
            //         Body: `Здравствуйте, уведомляем Вас, что следующий документ был отправлен на доработку:<br/><br/><a href="${siteUrl}/dashboard/1?documentCard=${documentId}">${mainDoc.Title}</a><br/><br/>Комментарий от системы: Отправлено на доработку в связи с обновлениями системы. Пожалуйста, проверьте и отправьте документ на согласование повторно. Обновите дату пересмотра и загрузите актуальный файл`,
            //         DateToBeSentAt: moment().subtract(12, "hours").toDate(),
            //         Title: "Мои Документы | Отправка на доработку документа",
            //         Subject: "Мои Документы | Отправка на доработку документа",
            //         Recepients: mainDoc.AuthorEmail.toLowerCase(),
            //         CheckDoc: `${documentId}`,
            //       };
            //       sendEmail(emailBody);
            //     }

            //     console.log(`✅ Документ ${documentId} полностью обработан и отправлен на доработку`);

            //   } catch (error) {
            //     console.error(`❌ Ошибка при обработке документа ${documentId} (попытка ${attempt}):`, error);

            //     if (attempt < maxAttempts) {
            //       console.log(`Повторная попытка через 2 секунды...`);
            //       await new Promise(resolve => setTimeout(resolve, 2000));
            //       return deleteDocumentAndRelatedData(documentId, attempt + 1);
            //     } else {
            //       console.error(`❌ Документ ${documentId} не удалось обработать после ${maxAttempts} попыток`);
            //     }
            //   }
            // };
            // const processAllDocuments = async () => {
            //   console.log(`🚀 Начинаем обработку ${documents.length} документов...`);

            //   let successCount = 0;
            //   let failedCount = 0;

            //   for (const docId of documents) {
            //     await deleteDocumentAndRelatedData(docId);
            //     // Небольшая задержка между документами, чтобы не перегружать сервер
            //     await new Promise(resolve => setTimeout(resolve, 800));
            //   }
            //   console.log(`🏁 Обработка завершена! Успешно: ${successCount}, Ошибок: ${failedCount}`);
            // };
            // // Запуск
            // processAllDocuments().then(() => {
            //   setAuth(true);
            // });
          });
        });
      });
    }
  }, [isAuthenticated]);

  return <></>;
};

export default HeadInfo;
